import { InfoIcon } from '../../assets/icons';
import { Tooltip } from 'react-tooltip';
import { v4 as uuidv4 } from 'uuid';
import React, { useState } from 'react';
import clsx from 'clsx';

export type TooltipPlace =
  | 'top'
  | 'top-start'
  | 'top-end'
  | 'right'
  | 'right-start'
  | 'right-end'
  | 'bottom'
  | 'bottom-start'
  | 'bottom-end'
  | 'left'
  | 'left-start'
  | 'left-end';
export const Info = (props: {
  tooltipText: string;
  tooltipWidth: number;
  tooltipPlace?: TooltipPlace;
  tooltipFixOverflow?: boolean;
  isSmall?: boolean;
  dataTest?: string;
}) => {
  const { tooltipText, tooltipWidth, tooltipPlace, tooltipFixOverflow, isSmall, dataTest } = props;
  const [tooltipId] = useState(`tooltip-id_${uuidv4()}`);

  return (
    <>
      <button
        className={clsx('icon-button__wrapper', { 'icon-button__wrapper--small': isSmall })}
        type="button"
        tabIndex={-1}
        data-test={dataTest}
      >
        <InfoIcon
          className="icon-button__icon"
          data-tooltip-id={tooltipId}
          data-tooltip-place={tooltipPlace ?? 'bottom'}
        />
      </button>
      <Tooltip
        id={tooltipId}
        className="info-button__tooltip"
        noArrow={true}
        style={{ width: tooltipWidth }}
        place={'bottom'}
        positionStrategy={tooltipFixOverflow ? 'fixed' : 'absolute'}
      >
        <div className="info-button__tooltip-content">{tooltipText}</div>
      </Tooltip>
    </>
  );
};
